module.exports = __webpack_public_path__ + "img/av218.eec7a276.png";